import { saveAs } from "file-saver";
import Util from "../../global/utils/Helpers";
import { store } from "../../global/app/store";

const getpdf = async (case_number) => {
  const { dispatch } = store;
  let apiIndex = Util.isLocalhost()
    ? `http://localhost:9393/auth/document/dh/case-document/${case_number}`
    : `${Util.getCurrentHost()}/auth/auth/document/dh/case-document/${case_number}`;

  await fetch(apiIndex, {
    credentials: "include",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization:
        "Basic " +
        window.btoa("flagdevteam1:account-standard-xxxxx44xx3xxxxxxxxxxxx1"),
    },
  })
    .then((r) => {
      if (!r.ok) {
        throw Error();
      }
      return r.blob();
    })
    .then((blob) => {
      if (blob.size > 0) {
        // saveAs(blob, fileName);
        window.open(URL.createObjectURL(blob));
      } else {
        throw Error();
      }
    })
    .catch(function (e) {
      const OFLC_GET_PDF_FAILURE = "OFLC_GET_PDF_FAILURE";
      function oflcFaildPdfFetch() {
        return {
          type: OFLC_GET_PDF_FAILURE,
          payload: {
            status: "info",
            message: "No PDF available for this case yet. Check back later.",
          },
        };
      }
      dispatch(oflcFaildPdfFetch());
    });
};

export default getpdf;
